export default __webpack_public_path__ + "static/media/mascot 1.d4b6ff35.png";